import { render, staticRenderFns } from "./SAccProjectContentDialog.vue?vue&type=template&id=63e69bcc&scoped=true"
import script from "./SAccProjectContentDialog.vue?vue&type=script&lang=ts"
export * from "./SAccProjectContentDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e69bcc",
  null
  
)

export default component.exports